import {
	createRouter,
	createWebHistory
} from "vue-router";
import Home from "../views/Home.vue";
const routes = [{
		path: '/',
		redirect: '/login'
	},
	{
		path: "/",
		name: "Home",
		component: Home,
		children: [{
			path: "/member",
			name: "member",
			meta: {
				title: '会员列表'
			},
			component: () => import(
				"../views/member.vue")
		}, {
			path: "/distributor",
			name: "distributor",
			meta: {
				title: '经销商列表'
			},
			component: () => import(
				"../views/distributor.vue")
		}, {
			path: "/historyMsg",
			name: "historyMsg",
			meta: {
				title: '客户历史评级列表'
			},
			component: () => import(
				"../views/historyMsg.vue")
		}, {
			path: "/person",
			name: "person",
			meta: {
				title: '角色管理'
			},
			component: () => import(
				"../views/person.vue")
		}, {
			path: "/classificationList",
			name: "classificationList",
			meta: {
				title: '分类列表'
			},
			component: () => import(
				"../views/classificationList.vue")
		}, {
			path: "/seriesList",
			name: "seriesList",
			meta: {
				title: '系列列表'
			},
			component: () => import(
				"../views/seriesList.vue")
		}, {
			path: "/user",
			name: "user",
			meta: {
				title: '用户管理'
			},
			component: () => import(
				"../views/user.vue")
		}, {
			path: "/companyIntr",
			name: "companyIntr",
			meta: {
				title: '公司介绍'
			},
			component: () => import(
				"../views/companyIntr.vue")
		}, {
			path: "/newsActive",
			name: "newsActive",
			meta: {
				title: '新闻活动'
			},
			component: () => import(
				"../views/newsActive.vue")
		}, {
			path: "/fwxy",
			name: "CCS-fwxy",
			meta: {
				title: '服务协议'
			},
			component: () => import(
				"../views/CCS/CCS-fwxy")
		}, {
			path: "/splc",
			name: "CCS-splc",
			meta: {
				title: '送评流程'
			},
			component: () => import(
				"../views/CCS/CCS-splc")
		}, {
			path: "/pjfw",
			name: "CCS-pjfw",
			meta: {
				title: '评级范围'
			},
			component: () => import(
				"../views/CCS/CCS-pjfw")
		}, {
			path: "/pjbz",
			name: "CCS-pjbz",
			meta: {
				title: '评级标准'
			},
			component: () => import(
				"../views/CCS/CCS-pjbz")
		}, {
			path: "/pjfy",
			name: "CCS-pjfy",
			meta: {
				title: '评级费用'
			},
			component: () => import(
				"../views/CCS/CCS-pjfy")
		}, {
			path: '/lunbo',
			name: 'lunbo',
			meta: {
				title: '轮播图管理'
			},
			component: () => import(
				'../views/lunbo.vue')
		}, {
			path: '/pingjiList',
			name: 'pingjiList',
			meta: {
				title: '评级列表'
			},
			component: () => import(
				'../views/pingjiList.vue')
		}, {
			path: '/goodsList',
			name: 'goodsList',
			meta: {
				title: '商品列表'
			},
			component: () => import(
				'../views/goodsList.vue')
		}, {
			path: '/Ratingpool',
			name: 'Ratingpool',
			meta: {
				title: '评级池'
			},
			component: () => import(
				'../views/Ratingpool.vue')
		}, {
			path: '/Orderprinting',
			name: 'Orderprinting',
			meta: {
				title: '订单打印'
			},
			component: () => import(
				'../views/Orderprinting.vue')
		}, {
			path: '/dataStatistics',
			name: 'dataStatistics',
			meta: {
				title: '评级数据统计'
			},
			component: () => import(
				'../views/dataStatistics.vue')
		}, {
			path: '/completeRating',
			name: 'completeRating',
			meta: {
				title: '完成评级'
			},
			component: () => import(
				'../views/completeRating.vue')
		}, {
			path: '/about',
			name: 'about',
			meta: {
				title: '联系我们'
			},
			component: () => import(
				'../views/About.vue')
		}, {
			path: '/404',
			name: '404',
			meta: {
				title: '找不到页面'
			},
			component: () => import( /* webpackChunkName: "404" */
				'../views/404.vue')
		}, {
			path: '/403',
			name: '403',
			meta: {
				title: '没有权限'
			},
			component: () => import( /* webpackChunkName: "403" */
				'../views/403.vue')
		}, {
			path: '/cgList',
			name: 'cgList',
			meta: {
				title: '草稿列表'
			},
			component: () => import( /* webpackChunkName: "403" */
				'../views/cgList.vue')
		}, {
			path: '/qfList',
			name: 'qfList',
			meta: {
				title: '群发列表'
			},
			component: () => import( /* webpackChunkName: "403" */
				'../views/qfList.vue')
		}]
	}, {
		path: "/login",
		name: "Login",
		meta: {
			title: '登录'
		},
		component: () => import(
			/* webpackChunkName: "login" */
			"../views/Login.vue")
	}, {
		path: "/register",
		name: "Register",
		meta: {
			title: '注册'
		},
		component: () => import(
			"../views/Register.vue")
	},
	{
		path: "/echart",
		name: "echart",
		meta: {
			title: '大屏'
		},
		component: () => import(
			"../views/echart.vue")
	},
	{
		path: "/yulan",
		name: "yulan",
		meta: {
			title: '预览'
		},
		component: () => import(
			"../views/yulan.vue")
	}
];

const router = createRouter({
	// history: createWebHistory(process.env.BASE_URL),
	history: createWebHistory(process.env.BASE_AXIOSAPI),
	routes
});

router.beforeEach((to, from, next) => {
	document.title = `${to.meta.title} | FCS管理系统`;
	const role = localStorage.getItem('RoleId');
	if (!role && to.path !== '/login') {
		next('/login');
	} else {
		next();
	}
});

export default router;
